var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDc5C4C4Fac6C702Affb82Eaa187307A290Cd6Aaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.8 16.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.44 5.03687C13.44 5.9661 14.1902 6.71582 15.12 6.71582C16.0498 6.71582 16.8 7.46555 16.8 8.39478C16.8 9.32401 16.0498 10.0737 15.12 10.0737C14.1902 10.0737 13.44 9.32401 13.44 8.39478C13.44 7.46555 12.6898 6.71582 11.76 6.71582C10.8302 6.71582 10.08 5.9661 10.08 5.03687C10.08 4.10763 9.32981 3.35791 8.4 3.35791C7.47019 3.35791 6.72 4.10763 6.72 5.03687C6.72 5.9661 5.96981 6.71582 5.04 6.71582C4.11019 6.71582 3.36 5.9661 3.36 5.03687C3.36 4.10763 4.11019 3.35791 5.04 3.35791C5.96981 3.35791 6.72 2.60819 6.72 1.67896C6.72 0.749723 7.47019 0 8.4 0C9.32981 0 10.08 0.749723 10.08 1.67896C10.08 2.60819 10.8302 3.35791 11.76 3.35791C12.6898 3.35791 13.44 4.10763 13.44 5.03687Z",
    fill: "url(#paint0_linear_2011_1719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76 10.0842C12.6898 10.0842 13.44 10.8339 13.44 11.7631C13.44 12.6924 12.6898 13.4421 11.76 13.4421C10.8302 13.4421 10.08 12.6924 10.08 11.7631C10.08 10.8339 9.32981 10.0842 8.4 10.0842C7.47019 10.0842 6.72 10.8339 6.72 11.7631C6.72 12.6924 7.47019 13.4421 8.4 13.4421C9.32981 13.4421 10.08 14.1918 10.08 15.121C10.08 16.0503 9.32981 16.8 8.4 16.8C7.47019 16.8 6.72 16.0503 6.72 15.121C6.72 14.1918 5.96981 13.4421 5.04 13.4421C4.11019 13.4421 3.36 12.6924 3.36 11.7631C3.36 10.8339 2.60981 10.0842 1.68 10.0842C0.750189 10.0842 0 9.33446 0 8.40522C0 7.47599 0.750189 6.72627 1.68 6.72627C2.60981 6.72627 3.36 7.47599 3.36 8.40522C3.36 9.33446 4.11019 10.0842 5.04 10.0842C5.96981 10.0842 6.72 9.33446 6.72 8.40522C6.72 7.47599 7.47019 6.72627 8.4 6.72627C9.32981 6.72627 10.08 7.47599 10.08 8.40522C10.08 9.33446 10.8302 10.0842 11.76 10.0842Z",
    fill: "url(#paint1_linear_2011_1719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 5.69143C8.7617 5.69143 9.05499 5.39831 9.05499 5.03674C9.05499 4.67517 8.7617 4.38205 8.3999 4.38205C8.0381 4.38205 7.7448 4.67517 7.7448 5.03674C7.7448 5.39831 8.0381 5.69143 8.3999 5.69143Z",
    fill: "url(#paint2_linear_2011_1719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 12.4073C8.7617 12.4073 9.05499 12.1142 9.05499 11.7526C9.05499 11.391 8.7617 11.0979 8.3999 11.0979C8.0381 11.0979 7.7448 11.391 7.7448 11.7526C7.7448 12.1142 8.0381 12.4073 8.3999 12.4073Z",
    fill: "url(#paint3_linear_2011_1719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7599 9.04936C12.1217 9.04936 12.415 8.75625 12.415 8.39468C12.415 8.0331 12.1217 7.73999 11.7599 7.73999C11.3981 7.73999 11.1048 8.0331 11.1048 8.39468C11.1048 8.75625 11.3981 9.04936 11.7599 9.04936Z",
    fill: "url(#paint4_linear_2011_1719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03987 9.04936C5.40167 9.04936 5.69497 8.75625 5.69497 8.39468C5.69497 8.0331 5.40167 7.73999 5.03987 7.73999C4.67807 7.73999 4.38478 8.0331 4.38478 8.39468C4.38478 8.75625 4.67807 9.04936 5.03987 9.04936Z",
    fill: "url(#paint5_linear_2011_1719)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_1719",
    x1: -1.79539e-8,
    y1: 16.8,
    x2: 16.8,
    y2: 0.00000188939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2011_1719",
    x1: -1.79539e-8,
    y1: 16.8,
    x2: 16.8,
    y2: 0.00000188939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2011_1719",
    x1: -1.79539e-8,
    y1: 16.8,
    x2: 16.8,
    y2: 0.00000188939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2011_1719",
    x1: -1.79539e-8,
    y1: 16.8,
    x2: 16.8,
    y2: 0.00000188939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2011_1719",
    x1: -1.79539e-8,
    y1: 16.8,
    x2: 16.8,
    y2: 0.00000188939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2011_1719",
    x1: -1.79539e-8,
    y1: 16.8,
    x2: 16.8,
    y2: 0.00000188939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc5C4C4Fac6C702Affb82Eaa187307A290Cd6Aaa);
export default __webpack_public_path__ + "static/media/dc5c4c4fac6c702affb82eaa187307a290cd6aaa.c0461f5d2b5400ab890b83b1ecf6b1fc.svg";
export { ForwardRef as ReactComponent };